import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
interface ProblemProofProps {
  onScrollToSection?: (sectionId: string) => void;
}
export function ProblemProof({
  onScrollToSection
}: ProblemProofProps) {
  const {
    t
  } = useLanguage();
  const stats = [{
    number: t('problem.stat1.value'),
    label: t('problem.stat1.label')
  }, {
    number: t('problem.stat2.value'),
    label: t('problem.stat2.label')
  }, {
    number: t('problem.stat3.value'),
    label: t('problem.stat3.label')
  }];
  const handleWaitlistClick = () => {
    if (onScrollToSection) {
      onScrollToSection('waitlist');
    }
  };
  return <section className="w-full py-32 px-6 bg-black text-white" data-id="element-313" data-mp="18q9aik7tocxk">
      <div className="max-w-5xl mx-auto" data-id="element-314" data-mp="3oi6mj86ces7a">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-315" data-mp="3oh594x1uttme">
          <h2 className="text-6xl md:text-8xl font-black mb-8 uppercase tracking-tighter leading-none" data-id="element-316" data-mp="2l5o3b3wpguuf">
            {t('problem.title')}
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-317" data-mp="2v0g38edrftsd">
            {t('problem.subtitle')}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-318" data-mp="38z5vngpmx5ae">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="border-2 border-white p-8 text-center" data-id="element-319" data-mp="3ir27rvok2vxm" data-mpi={index}>
              <p className="text-5xl font-black mb-4" data-id="element-320" data-mp="3n1sgyay7ex2">{stat.number}</p>
              <p className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-321" data-mp="3nbiglvztm2r">
                {stat.label}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="border-t border-b border-white py-12 text-center" data-id="element-322" data-mp="ddn01b8lnts4">
          <p className="text-2xl font-black mb-6 uppercase tracking-tight" data-id="element-323" data-mp="waei5hceo2ul">
            {t('problem.impact.title')}
          </p>
          <p className="text-gray-400 mb-8 max-w-2xl mx-auto" data-id="element-324" data-mp="2t62cl80tf9fk">
            {t('problem.impact.text')}
          </p>
          <button onClick={handleWaitlistClick} className="px-12 py-5 bg-white text-black font-black text-lg hover:bg-gray-200 border-2 border-white transition-all duration-300 uppercase tracking-widest rounded-full shadow-lg hover:shadow-xl hover:scale-105" data-id="element-325" data-mp="1f7y4u060yyk2">
            {t('problem.cta')}
          </button>
        </motion.div>
      </div>
    </section>;
}